module.exports = __webpack_public_path__ + "img/61200.958f5180.jpg";